var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Emit } from "vue-property-decorator";
import ConfigBase from "./config-base.vue";
import DistributeRule from "./distribute-rule.vue";
import DistributionPattern from "~/components/distribution-common/distribution-pattern.vue";
import { StrategyConfigService } from "~/services/dataimp-service/strategy-config.service";
import { FilterService } from "~/utils/filter.service";
import { State } from "vuex-class";
var ModifyConfig = /** @class */ (function (_super) {
    __extends(ModifyConfig, _super);
    function ModifyConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentTab = "config-base";
        _this.id = "";
        _this.distributeMode = "";
        _this.distributeModel = {};
        _this.configBaseModel = {};
        _this.val = {};
        return _this;
    }
    ModifyConfig.prototype.emitClose = function () {
        this.currentTab = "config-base";
        this.initData();
    };
    ModifyConfig.prototype.emitSuccess = function () {
        this.$message.success("操作成功");
        this.emitClose();
    };
    ModifyConfig.prototype.refresh = function () {
        if (this.strategyId) {
            this.strategyConfigService
                .getOneById(this.strategyId)
                .subscribe(this.revertDataNext);
        }
        else {
            this.initData();
        }
    };
    ModifyConfig.prototype.submit = function () {
        var _this = this;
        if ((this.distributeModel.assignModel === 'COLLECTOR' || (this.configBaseModel.casePoolTypes && (this.configBaseModel.casePoolTypes[0] === 'WAIT_DISTRIBUTION' || this.configBaseModel.casePoolTypes[0] === 'RECOVERED_DISTRIBUTION'))) && this.distributeModel.collectionDays > this.distributeModel.limitDays) {
            this.$message.error("催收天数不能大于" + this.distributeModel.limitDays);
            return;
        }
        if (this.distributeModel.assignModel !== 'COLLECTOR' && this.configBaseModel.casePoolTypes && this.configBaseModel.casePoolTypes[0] !== 'WAIT_DISTRIBUTION' && this.configBaseModel.casePoolTypes[0] !== 'RECOVERED_DISTRIBUTION') {
            this.distributeModel.collectionDays = '';
            this.distributeModel.limitDays = '';
        }
        var panels = ["config-base", "distribute-rule"];
        var validates = panels.map(function (v) {
            var component = _this.$refs[v];
            return component.validate().catch(function (e) { return Promise.reject(e); });
        });
        Promise.all(validates)
            .then(function (x) {
            var result = __assign(__assign(__assign({}, _this.distributeModel), _this.configBaseModel), { id: _this.id });
            if (_this.id) {
                _this.strategyConfigService
                    .updateStrategy(result)
                    .subscribe(_this.emitSuccess);
            }
            else {
                _this.strategyConfigService
                    .createStrategy(result)
                    .subscribe(_this.emitSuccess);
            }
        })
            .catch(function (v) { return (_this.currentTab = v); });
    };
    /**
     * 作废/终止
     */
    ModifyConfig.prototype.terminationClick = function (val) {
        var _this = this;
        var terminationModel = {
            id: this.id,
            strategyStatus: val === 1 ? "ABOLISHED" : "TERMINATED"
        };
        this.strategyConfigService
            .updateStrategyStatus(terminationModel)
            .subscribe(function (data) {
            _this.$message.success("操作成功！");
            _this.emitClose();
            _this.initData();
            _this.emitSuccess();
        });
    };
    ModifyConfig.prototype.initData = function () {
        this.id = "";
        this.distributeModel = {
            assignModel: "",
            departmentId: "",
            departmentIds: [],
            strategyCaseType: "",
            users: [],
            distributeType: "",
            outEndCycle: "",
            distributeMode: "",
            collectionDays: '',
            limitDays: ''
        };
        this.configBaseModel = {
            strategyStatus: "READY",
            commonState: "",
            formulaJson: "[]",
            name: "",
            strategyType: "",
            priority: 5,
            casePoolTypes: []
        };
        this.distributeMode = "";
        var configBaseTab = this.$refs["config-base"];
        if (configBaseTab)
            configBaseTab.reset();
        var distributeRuleTab = this.$refs["distribute-rule"];
        if (distributeRuleTab)
            distributeRuleTab.reset();
    };
    /**
     * 回显数据下一步
     */
    ModifyConfig.prototype.revertDataNext = function (val) {
        var outData = [];
        if (val.outsourceIds) {
            this.outSourceList.map(function (v) {
                if (val.outsourceIds.find(function (m) { return m === v.id; })) {
                    outData.push({
                        outsourceId: v.id,
                        outsName: v.outsName
                    });
                }
            });
        }
        this.val = val;
        this.id = val.id;
        this.distributeModel = {
            assignModel: val.assignModel,
            departmentId: val.departmentId,
            strategyCaseType: val.strategyCaseType,
            users: val.users,
            distributeType: val.distributeType,
            distributeMode: val.distributeMode,
            outEndCycle: val.outEndCycle,
            entrustData: outData,
            collectionDays: val.collectionDays
        };
        this.configBaseModel = {
            casePoolTypes: val.casePoolTypes,
            strategyStatus: val.strategyStatus,
            executionFrequency: val.executionFrequency,
            startDate: FilterService.dateTimeFormat(val.startDate),
            endDate: FilterService.dateTimeFormat(val.endDate),
            commonState: val.commonState,
            formulaJson: val.formulaJson,
            name: val.name,
            strategyType: val.strategyType,
            priority: val.priority,
            timeType: val.timeType,
            intervals: val.intervals
        };
        this.distributeMode = val.distributeMode;
    };
    ModifyConfig.prototype.created = function () {
        this.initData();
    };
    __decorate([
        Dependencies(StrategyConfigService)
    ], ModifyConfig.prototype, "strategyConfigService", void 0);
    __decorate([
        State
    ], ModifyConfig.prototype, "outSourceList", void 0);
    __decorate([
        Prop({ required: true })
    ], ModifyConfig.prototype, "strategyId", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], ModifyConfig.prototype, "disabledData", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], ModifyConfig.prototype, "show", void 0);
    __decorate([
        Emit("close")
    ], ModifyConfig.prototype, "emitClose", null);
    __decorate([
        Emit("success")
    ], ModifyConfig.prototype, "emitSuccess", null);
    ModifyConfig = __decorate([
        Component({
            components: {
                ConfigBase: ConfigBase,
                DistributeRule: DistributeRule,
                DistributionPattern: DistributionPattern
            }
        })
    ], ModifyConfig);
    return ModifyConfig;
}(Vue));
export default ModifyConfig;
